module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.imglist) ? _c('div', {
    staticClass: "students-list",
    class: _vm.className
  }, [(!_vm.students.length) ? _c('p', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\tEsta turma não possui nenhum aluno\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.students.length) ? _c('ul', {
    staticClass: "general-item-list list-unstyled row"
  }, _vm._l((_vm.students), function(student) {
    return _c('li', {
      key: student.id,
      staticClass: "item col-md-3 col-sm-6 col-xs-6"
    }, [_c('a', {
      staticClass: "btn btn-block btn-link btn-list p-10 relative",
      class: {
        'active': _vm.currentStudent.studentId === student.studentId
      },
      on: {
        "click": function($event) {
          _vm.setCurrentStudent(student)
        }
      }
    }, [_c('img', {
      staticClass: "item-pic rounded student-picture-list",
      attrs: {
        "width": "35px",
        "height": "35px",
        "src": student.photoURL
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "truncate font-grey-gallery"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(student.name.toLowerCase()) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('small', {
      staticClass: "absolute",
      class: _vm.getStatusLabelColor(student.status)
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("agendaStatus")(student.status)) + "\n\t\t\t\t\t")])])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.imglist) ? _c('div', [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "control-label"
  }, [_vm._v("Alunos:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "disabled": _vm.disabled,
      "label": "name",
      "options": _vm.students,
      "value": _vm.students,
      "placeholder": "Selecione os estudantes:"
    },
    on: {
      "input": function($event) {
        _vm.setCurrentStudent(_vm.student)
      }
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fdc0612","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/student/students.vue
// module id = 1092
// module chunks = 1